function getPathFromId(id){
    if (!id) return '';
    return id.split('_').slice(1).join('.');
}

export default getPathFromId;